import { useMutation } from '@tanstack/react-query';
import axios from 'axios';
import { TRUCK_SHIFT_UPDATE_MUTATION_KEY } from 'src/hooks/useIsTruckShiftUpdating';
import { CopyRequestBody } from 'src/pages/TruckShifts/truckShiftCopy';

export const COPY_PATH = '/api/v5/truck_shifts/copy';

export type CopyResult = { created_count: number; deleted_count: number };

export const useMutationTruckShiftCopy = () => useMutation(
  async (body: CopyRequestBody): Promise<CopyResult> => {
    const response = await axios.post<CopyResult>(COPY_PATH, body);
    return response.data;
  },
  {
    // 稼働表更新として識別する mutationKey（右下「稼働表を更新中」＋編集ロックが働く）。
    // 成功時の invalidate は App の MutationCache にこの key で集約（画面 unmount 後の完了でも再取得するため）。
    mutationKey: TRUCK_SHIFT_UPDATE_MUTATION_KEY,
  },
);
